import * as React from "react";
import { HashRouter as Router } from "react-router-dom";
import TopNav from "components/top-nav";
import Footer from "components/footer";
import Navigation from "components/Navigation";
import "style/style.css";

const Layout = () => (
  <Router>
    <div className="site-shell">
      <TopNav />
      <main className="site-main">
        <Navigation />
      </main>
      <Footer />
    </div>
  </Router>
);

export default Layout;
